class ExpandableText
    constructor: (el) ->
        @.$el = el
        @.$textContent = @.$el.querySelector '.expandable-text__text'
        @.$toggleButton = @.$el.querySelector '.expandable-text__toggle'

        @.resizeDelay = 300
        @.resizeInterval = undefined

        @.InitEvents()
        @.CheckForContentOverflow()
        @.$el.classList.add 'expandable-text--bound'
        return
    
    CheckForContentOverflow: ->
        if !@.$el.classList.contains 'expandable-text--open'
            if @.$textContent.clientHeight >= @.$textContent.scrollHeight
                @.$el.classList.add 'expandable-text--no-overflow'
            else
                @.$el.classList.remove 'expandable-text--no-overflow'
        else
            @.$el.classList.remove 'expandable-text--no-overflow'
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'expandable-text-toggle', (e) ->
            forced = e.detail?.forced ? false
            self.ToggleOpen forced
            return
        @.$toggleButton.addEventListener 'click', (e) ->
            self.ToggleOpen()
            return
        window.addEventListener 'resize', (e) ->
            window.clearInterval self.resizeInterval
            self.resizeInterval = window.setInterval ->
                window.clearInterval self.resizeInterval
                self.CheckForContentOverflow()
            , self.resizeDelay
        return
    
    ToggleOpen: (forced)->
        self = @
        if !@.$el.classList.contains 'expandable-text--no-overflow'
            @.$el.classList.toggle 'expandable-text--open'
            if !forced
                @.$el.dispatchEvent new CustomEvent 'expandable-text-toggled', {
                    bubbles: false
                    detail: {
                        open: self.$el.classList.contains 'expandable-text--open'
                    }
                }
        return

BindExpandableTexts = ->
    document.querySelectorAll '.expandable-text:not(.expandable-text--bound)'
        .forEach (el) ->
            new ExpandableText el
            return
    return

window.addEventListener 'bind-components', BindExpandableTexts

class ExpandableTextCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bindLater = options?.bindLater ? false
        @.collapsedLines = parseInt options?.collapsedLines, 10
        @.collapsedLines = if !isNaN(@.collapsedLines) then @.collapsedLines else 4
        @.collapseText = options?.collapseText ? 'Details zuklappen'
        @.expandText = options?.expandText ? 'Details aufklappen'
        @.open = options?.open ? false
        @.tag = options?.tag ? 'div'
        @.text = options?.text ? 'Text'

        @.CreateElement()
        if !@.bindLater
            new ExpandableText @.$el
        return @.$el

    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'expandable-text'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.open
            @.$el.classList.add 'expandable-text--open'
        @.$el.innerHTML = "
            <div class='expandable-text__text' style='max-height:#{ @.collapsedLines * 1.5 }em;'></div>
            <button type='button' class='expandable-text__toggle icon-chevron-after'>
                <span class='expandable-text__expand'>#{ @.expandText }</span>
                <span class='expandable-text__collapse'>#{ @.collapseText }</span>
            </button>
        "
        @.$el.querySelector '.expandable-text__text'
            .appendChild window.CreateRichtext {
                textContent: @.text
            }
        return

window.CreateExpandableText = (options) ->
    return new ExpandableTextCreate options